import { cva, type VariantProps } from 'class-variance-authority';

/**
 * HEN ArticleCard variants using HEN Design System tokens.
 * All styling references design tokens defined in tailwind.config.ts.
 */

/**
 * Container styles for the card wrapper
 */
export const articleCardContainerVariants = cva('', {
  variants: {
    layout: {
      vertical: 'flex flex-col',
      horizontal: 'flex flex-row items-start',
    },
    gap: {
      md: 'gap-md',
      sm: 'gap-sm',
      xxs: 'gap-xxs',
    },
    hoverStyle: {
      none: '',
      shadow:
        'transition-shadow duration-normal ease-out md:hover:shadow-md motion-reduce:transition-none',
    },
  },
  defaultVariants: {
    layout: 'vertical',
    gap: 'md',
    hoverStyle: 'none',
  },
});

/**
 * Image styles based on size variant
 */
const hoverZoom =
  'transition-transform duration-normal ease-out motion-reduce:transition-none md:group-hover:scale-hover-zoom';

export const articleCardImageVariants = cva('object-cover', {
  variants: {
    size: {
      lg: `w-full aspect-[636/380] ${hoverZoom}`,
      md: `w-full aspect-[636/380] ${hoverZoom}`,
      sm: `w-full aspect-[636/380] ${hoverZoom}`,
      compact: `w-20 h-20 flex-shrink-0 ${hoverZoom}`,
      xs: 'w-32 aspect-3/2 flex-shrink-0',
    },
    border: {
      none: '',
      padding: 'rounded-md',
      stroke: 'rounded-md',
      shadow: 'rounded-md',
    },
  },
  compoundVariants: [
    {
      size: ['lg', 'md', 'sm', 'compact'],
      border: 'none',
      class: 'rounded-lg',
    },
    {
      size: 'xs',
      border: 'none',
      class: 'rounded-md',
    },
    // Compact size with border uses smaller radius
    {
      size: ['compact', 'xs'],
      border: ['padding', 'stroke', 'shadow'],
      class: 'rounded-sm',
    },
  ],
  defaultVariants: {
    size: 'lg',
    border: 'none',
  },
});

export type ArticleCardContainerVariantProps = VariantProps<
  typeof articleCardContainerVariants
>;
export type ArticleCardImageVariantProps = VariantProps<
  typeof articleCardImageVariants
>;
